import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__ from "@orbit-ui/core";
import "react";
import * as __WEBPACK_EXTERNAL_MODULE__badge_variants_js_87930c11__ from "./badge-variants.js";
function Badge({ className, variant, isMini = false, ...properties }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: (0, __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__.cn)((0, __WEBPACK_EXTERNAL_MODULE__badge_variants_js_87930c11__.badgeVariants)({
            variant,
            isMini
        }), className),
        ...properties
    });
}
export { Badge };

//# sourceMappingURL=badge.js.map